<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <!-- <breadcrumb class="breadcrumb-container" /> -->

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <screenfull id="screenfull" class="right-menu-item hover-effect" />
      </template>
      <template>
        <el-select v-model="selectStatusValue" placeholder="状态" class="select">
          <el-option
            v-for="(item,index) in selectStatusList"
            :key="index"
            :label="item.value"
            :value="item.value">
          </el-option>
      </el-select>
      </template>

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img src="@/assets/MES.png" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/dashboard">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided  style="padding:0px">
            <span style="display:block;width:100%;height:100%;text-align:center;"  @click="logout">注销</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'

export default {
  data () {
    return {
      selectStatusList: [],
      selectStatusValue: '',
      List: [],
      switchFactoryForm: {
        loginWay: null,
        param: '',
        username: ''
      },
      userInfo: {}
    }
  },
  created () {
    // const value1 = window.sessionStorage.getItem('queryFactoryName')
    // const key1 = window.sessionStorage.getItem('queryFactoryName')
    // this.selectStatusList[0] = { value: value1, key: key1 }
    // this.selectStatusValue = value1
    if (window.sessionStorage.getItem('factoryNameList') !== null) {
      JSON.parse(window.sessionStorage.getItem('factoryNameList')).forEach(item => {
        this.selectStatusList.push({ value: item })
      })
    }
    this.switchFactoryForm.loginWay = parseInt(window.sessionStorage.getItem('type'))
    this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    if (this.switchFactoryForm.loginWay === this.$params.msg) {
      this.switchFactoryForm.param = this.userInfo.phone
    } else if (this.switchFactoryForm.loginWay === this.$params.wx) {
      this.switchFactoryForm.param = this.userInfo.unionId
    }
    if (window.sessionStorage.getItem('selectFactoryValue') === '') {
      this.selectStatusValue = this.selectStatusList[0].value
    } else {
      this.selectStatusValue = window.sessionStorage.getItem('selectFactoryValue')
    }
  },
  components: {
    // Breadcrumb,
    Hamburger,
    Screenfull
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'device'])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout () {
      this.$router.push('/login')
      this.$Message.success('注销成功')
      setTimeout(() => {
        this.$store.commit('productOrder/initCache')
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.user-dropdown {
  top: 40px !important;
}
#Topping {
  margin-top: -10px;
}
.select {
  top: -14px;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
